<h3 class="schema__advantage-item-title">{{ 'main.schemas.nativeSpeakingSupport' | translate }}</h3>

<div class="schema__card schema__paragraph-regular">
  {{ 'main.schemas.receivePrompt' | translate }}
</div>

<img
  width="200"
  loading="lazy"
  alt="Three AstralFund credit cards"
  src="/assets/schemas/card-1-bg.png"
  class="schema__image"
/>
